import { render } from "./ProductSelectInput.vue?vue&type=template&id=5443b0d9&scoped=true"
import script from "./ProductSelectInput.vue?vue&type=script&lang=js"
export * from "./ProductSelectInput.vue?vue&type=script&lang=js"

import "./ProductSelectInput.vue?vue&type=style&index=0&id=5443b0d9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5443b0d9"]])

export default __exports__